import { DateTime, Exercise, Measurement } from "types";
import { useEffect, useMemo, useState } from "react";
import MeasurementService from "services/MeasurementService";
import { getTodayDateRangeParams } from "../../AthleteProfileActivityFeed.helpers";
import groupBy from "lodash/groupBy";
import useRequest from "hooks/useRequest";
import useExercises from "providers/ExercisesProvider/useExercises";
import { firstBy } from "thenby";
import useNaturalSort from "hooks/useNaturalSort";

function useActivityFeedAllActivity(props: { id: string; date: DateTime }) {
  const { id, date } = props;
  const [measurements, setMeasurements] = useState<Measurement[]>([]);
  const handleGetMeasurementsByAthleteId = useRequest(MeasurementService.getByAthleteId);
  const exercises = useExercises();
  const naturalCompare = useNaturalSort();

  useEffect(() => {
    const dateParams = getTodayDateRangeParams(date);
    (async () => {
      const result = await handleGetMeasurementsByAthleteId(id, { ...dateParams });
      setMeasurements(result ?? []);
    })();
  }, [date, handleGetMeasurementsByAthleteId, id]);

  return useMemo(() => {
    const grouped = Object.entries(groupBy(measurements, (measurement) => measurement.exerciseId)).map(
      ([key, value]) => ({
        exerciseId: key,
        exercise: exercises.find((exercise) => exercise.id === key),
        measurements: value,
      })
    );

    const sorted = grouped
      .sort(
        firstBy<{ exercise?: Exercise }>((a, b) =>
          naturalCompare(a.exercise?.name || "", b.exercise?.name || "")
        ).thenBy((a, b) => naturalCompare(a.exercise?.category || "", b.exercise?.category || ""))
      )
      .map(({ exercise, ...rest }) => rest);

    return sorted;
  }, [exercises, naturalCompare, measurements]);
}

export default useActivityFeedAllActivity;
